module.exports = __webpack_public_path__ + "static/media/papeleria.365fea80.svg";